<template>
    <div id="content-maintop" class="search-main-wrap">
            <div @click="moresClick"  class="maintop-title" :class="mores?' ':'titleNone'">
                检索
                <span class="content-more" v-if="!showback">
                    <Icon v-if="!arrType" type="chevron-up" ></Icon>
                    <Icon v-if="arrType" type="chevron-down" ></Icon>
                </span>
                <span v-else class="content-more" @click.prevent.stop="goBack()"><Icon type="chevron-left"></Icon>返回结算单列表</span>
            </div>
            <div class="maintop-conent" v-show="mores">
                <slot name="one"></slot>
                <slot name="two"></slot>
                <slot name="three"></slot>
                <Row style="marginTop:1.5%">
                    <Col span="24">
                        <div class="">
                            <div class="maintop-search" @click="search()">查询</div>
                            <div class="maintop-loop" @click="reset($event)">重置</div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
</template>
<script>
export default {
  data() {
    return {
      arrType: false,
      mores: true,
      isSearch: false
    };
  },
  props:{
    showback:{
      type:Boolean,
      default:false
    }
  },
  methods: {
    init() {
      if (this.isTrue) {
        this.mores = true;
      }
    },
    moresClick() {
      if (!this.isTrue) {
        this.mores = !this.mores;
      }
      this.arrType = !this.arrType;
    },
    search() {
      this.isSearch = true;
      this.$emit("search", this.isSearch);
    },
    reset(event) {
      this.$emit("reset", event.target);
    },
    goBack() {
      this.$router.back();
    },
  },
  mounted() {
    this.init();
  }
};
</script>
<style scoped>
@import '../../common/css/searchUse.css'; 
#content-maintop {
  border: 1px solid #e6e6e6;
  background: #fff;
  border-radius: 4px;
  width: 100%;
  height: 100%;
  padding: 0 20px;
}
#content-maintop .titleNone {
  border-bottom: none;
}
#content-maintop .maintop-conent .ivu-row-flex {
  padding: 10px 0;
}
.maintop-conent {
  padding-bottom: 8px;
  margin-bottom: 10px;
  margin-top: 10px;
}
.maintop-buttons {
  line-height: 15px;
  text-align: center;
}
.maintop-search,
.maintop-loop {
  border: 1px solid #C6C6C6;
  border-radius: 4px;
  font-size: 12px;
  margin-right: 5px;
  cursor: pointer;
  width: 50px;
  height: 30px;
  outline: none;
  display: inline-block;
  line-height: 30px;
  text-align: center;
}
.maintop-search{
  border-color: #6236FF;
  background: #6236FF;
  color: #fff;
}
.maintop-loop {
  color: #212934;
}
.maintop-title {
    line-height: 25px;
    cursor: pointer;
    padding-left: 15px;
    font-size: 16px;
    padding-top: 20px;
    height: 73px;
}
.search-main-wrap .ivu-col {
  /* line-height: 32px; */
  /* text-align: center; */
}

.content-more {
  float: right;
  cursor: pointer;
}
.ivu-date-picker {
  width: 44%;
}
.buttons_box {
  margin-top: 1.5%;
}
.hideIcon {
  display: none;
}
</style>

